/**
 * Test IDs for QA automation.
 */
export const testIds = {
  relationshipsListNewRelation: "relationships-list-new-relation",
} as const;
